window.Parsley.addMessages('en', {
  defaultMessage: I18n.t('value_invalid') ,
  type: {
    email: I18n.t('email_format'),
    url: I18n.t('valid_url'),
    number: I18n.t('must_be_number'),
    integer: I18n.t('value_integer'),
    digits: I18n.t('value_digits'),
    alphanum: I18n.t('value_alphanumeric')
  },
  notblank: I18n.t('not_be_blank'),
  required: I18n.t('cant_be_blank'),
  pattern: I18n.t('value_invalid'),
  min: I18n.t('must_be_greater'),
  max: I18n.t('value_lower'),
  range: I18n.t('value_between'),
  minlength: I18n.t('value_too_short'),
  maxlength: I18n.t('characters_max'),
  length: I18n.t('value_length_invalid'),
  mincheck: I18n.t('select_least_choices'),
  maxcheck: I18n.t('select_choices_fewer'),
  check: I18n.t('select_between'),
  equalto: I18n.t('value_should_same')
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/parsley_locales.js